"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ = require("../");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SkeletonTable = function SkeletonTable(_ref) {
  var items = _ref.items;
  var rows = new Array(items).fill(0);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_.Card, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_.Skeleton, {
      display: "block",
      margin: "0.875rem 0 2.75rem"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_.Skeleton, {
      display: "block",
      skeletonWidth: "300px",
      margin: "0 0 3rem"
    }), rows.map(function (i, index) {
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_.Skeleton, {
          display: "block",
          skeletonWidth: "200px",
          margin: "0 0 2rem"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_.Skeleton, {
          display: "block",
          skeletonWidth: "100px",
          margin: "0 0 2rem"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_.Skeleton, {
          display: "block",
          skeletonWidth: "50px",
          margin: "0 0 2rem"
        })]
      }, "key-".concat(index));
    })]
  });
};

SkeletonTable.defaultProps = {
  items: 6
};
SkeletonTable.propTypes = {
  items: _propTypes.default.number
};
var _default = SkeletonTable;
exports.default = _default;